export * from './useDeviceInfo';
